import React, { useState, useEffect } from "react";
import AdminDashboard from "./admindashboard";
import { Form, Modal } from "react-bootstrap";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { FaTrash, FaEye, FaEyeSlash, FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router";
import "./hm-theme.css";

function Smtpconfigure() {
  const userid = JSON.parse(localStorage.getItem("data")).userid;
  const [smtpConfig, setSmtpConfig] = useState({
    host: "",
    port: "",
    username: "",
    password: "",
    adminlink: "",
  });
  const [configs, setConfigs] = useState([]);
  const [accounts, setAccounts] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfigPasswords, setShowConfigPasswords] = useState({});
  const [fromAddress, setFromAddress] = useState("");
  const [loading, setLoading] = useState(false);
  const [ccRecipients, setCcRecipients] = useState({
    adminId: "",
    ccRecipient: "",
  });
  const [selectedRecipient, setSelectedRecipient] = useState(null);
  const [ccRecipient, setCcRecipient] = useState({ id: "", ccRecipient: "" });
  const [isRecipientUpdateModal, setIsRecipientUpdateModal] = useState(false);
  const [existingCcRecipients, setExistingCcRecipients] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchConfigs();
  }, []);

  const fetchConfigs = async () => {
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("data")).token;

      const response = await axios.get(`/api/smtpconfiguration/adminlink=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setConfigs(response.data || []);

      const accRes = await axios.get(`/api/accounts/${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setAccounts(accRes.data);
      setFromAddress(accRes.data?.fromaddress || "");

      const ccRes = await axios.get(`/api/cc-recipients/adminId=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setExistingCcRecipients(ccRes.data || []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Error fetching configurations");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSmtpConfig((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = JSON.parse(localStorage.getItem("data")).token;

      const smtpConfigWithFromAddress = {
        ...smtpConfig,
        fromaddress: fromAddress,
      };

      await axios.post("/api/smtpconfiguration/create", smtpConfigWithFromAddress, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("SMTP configuration created successfully!");
      fetchConfigs();

      setSmtpConfig({
        host: "",
        port: "",
        username: "",
        password: "",
        adminlink: "",
      });
    } catch (error) {
      console.error(error);
      toast.error("Error creating SMTP configuration");
    }
  };

  const handleDelete = async (config) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this configuration?");
    if (confirmDelete) {
      try {
        setLoading(true);
        const token = JSON.parse(localStorage.getItem("data")).token;

        await axios.delete("/api/smtpconfiguration", {
          headers: { Authorization: `Bearer ${token}` },
          data: config,
        });

        toast.success("SMTP configuration deleted successfully!");
        fetchConfigs();
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error deleting SMTP configuration");
      }
    }
  };

  const handleDeleteCcRecipient = async (recipientId) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this cc recipient?");
    if (confirmDelete) {
      try {
        setLoading(true);
        const token = JSON.parse(localStorage.getItem("data")).token;

        await axios.delete("/api/cc-recipients", {
          headers: { Authorization: `Bearer ${token}` },
          data: {
            id: `${recipientId}`,
          },
        });

        toast.success("Cc Recipient deleted successfully!");
        fetchConfigs();
        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleError(error);
      }
    }
  };

  const handleSaveFromAddress = async () => {
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("data")).token;

      await axios.post(
        "/api/accounts/update/fromaddress",
        { fromAddress },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      toast.success("From Address updated successfully!");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error updating from address", error);
      toast.error("Error updating From Address");
    }
  };

  const handleUpdateRecipient = async (recipient) => {
    setSelectedRecipient(recipient);
    setCcRecipient({ id: recipient?.id, ccRecipient: recipient?.ccRecipient });
    setIsRecipientUpdateModal(true);
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value.trim();
    if (inputValue === "") return;
    setCcRecipients({ adminId: userid, ccRecipient: inputValue });
  };

  const handleChangeCc = (e) => {
    const { name, value } = e.target;
    setCcRecipient((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveCcRecipients = async () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!ccRecipients.ccRecipient || !emailPattern.test(ccRecipients.ccRecipient)) {
      toast.error("Please enter a valid email address");
      return;
    }
    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("data")).token;

      await axios.post("/api/cc-recipients/create", ccRecipients, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("CC Recipient added successfully!");
      setLoading(false);
      fetchConfigs();
      setCcRecipients({ adminId: userid, ccRecipient: "" });
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const handleUpdateSelectedRecipient = async () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!ccRecipient.ccRecipient || !emailPattern.test(ccRecipient.ccRecipient)) {
      toast.error("Please enter a valid email address");
      return;
    }

    try {
      setLoading(true);
      const token = JSON.parse(localStorage.getItem("data")).token;
      const updatedCcRecipient = {
        id: selectedRecipient?.id,
        ccRecipient: ccRecipient.ccRecipient,
      };

      await axios.post("/api/cc-recipients/update", updatedCcRecipient, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("CC Recipient updated successfully!");
      setLoading(false);
      fetchConfigs();
      setIsRecipientUpdateModal(false);
    } catch (error) {
      setLoading(false);
      toast.error("Failed to update recipient");
      console.error(error);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An error occurred.");
      }
    } else {
      toast.error("An error occurred.");
    }
  }

  const toggleConfigPasswordVisibility = (index) => {
    setShowConfigPasswords((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <div>
      <AdminDashboard />
      {loading && <div className="loading"></div>}
      <div className="col-10 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">
          {/* Page Header */}
          <div className="hm-page-header mb-4">
            <div>
              <h2 className="hm-page-title">
                <i className="material-icons">mark_email_read</i>
                SMTP Configuration
              </h2>
              <p className="hm-page-subtitle">
                Manage outgoing mail server settings, from address, and CC recipient lists.
              </p>
            </div>
          </div>

          <div className="row g-4">
            {/* Left Column - SMTP Form */}
            <div className="col-lg-6">
              <div className="hm-card h-100">
                <div className="hm-card-header">
                  <h3 className="hm-card-title">
                    <i className="material-icons">settings_remote</i>
                    SMTP Server Settings
                  </h3>
                </div>
                <div className="hm-card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3">
                      <div className="col-12">
                        <label htmlFor="host" className="form-label small fw-semibold">
                          Host <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="host"
                          name="host"
                          placeholder="e.g. smtp.gmail.com"
                          value={smtpConfig.host}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-12">
                        <label htmlFor="port" className="form-label small fw-semibold">
                          Port <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="port"
                          name="port"
                          placeholder="e.g. 587"
                          value={smtpConfig.port}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-12">
                        <label htmlFor="username" className="form-label small fw-semibold">
                          Username <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="username"
                          name="username"
                          placeholder="e.g. admin@domain.com"
                          value={smtpConfig.username}
                          onChange={handleChange}
                          required
                        />
                      </div>

                      <div className="col-12">
                        <label htmlFor="password" className="form-label small fw-semibold">
                          Password <span className="text-danger">*</span>
                        </label>
                        <div className="position-relative">
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control pe-5"
                            id="password"
                            name="password"
                            value={smtpConfig.password}
                            onChange={handleChange}
                            required
                          />
                          <span
                            onClick={() => setShowPassword(!showPassword)}
                            className="position-absolute end-0 top-50 translate-middle-y me-3 text-muted"
                            style={{ cursor: "pointer" }}
                          >
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                          </span>
                        </div>
                      </div>

                      <div className="col-12 text-end pt-2">
                        <button type="submit" className="btn-hm-primary">
                          <i className="material-icons" style={{ fontSize: "1rem" }}>
                            save
                          </i>
                          Create Configuration
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* Right Column - From Address & CC Recipients Input */}
            <div className="col-lg-6">
              <div className="d-flex flex-column gap-4">
                {/* From Address Card */}
                <div className="hm-card">
                  <div className="hm-card-header">
                    <h3 className="hm-card-title">
                      <i className="material-icons">alternate_email</i>
                      From Address
                    </h3>
                  </div>
                  <div className="hm-card-body">
                    <div className="row g-3">
                      <div className="col-12">
                        <label htmlFor="fromAddress" className="form-label small fw-semibold">
                          Sender Email Address
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="fromAddress"
                          value={fromAddress}
                          onChange={(e) => setFromAddress(e.target.value)}
                          placeholder="Enter From Address"
                          required
                        />
                      </div>
                      <div className="col-12 text-end">
                        <button
                          type="button"
                          className="btn-hm-primary"
                          onClick={handleSaveFromAddress}
                        >
                          Save Address
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* CC Recipients Card */}
                <div className="hm-card">
                  <div className="hm-card-header">
                    <h3 className="hm-card-title">
                      <i className="material-icons">forward_to_inbox</i>
                      Add CC Recipient
                    </h3>
                  </div>
                  <div className="hm-card-body">
                    <div className="row g-3">
                      <div className="col-12">
                        <label htmlFor="ccRecipients" className="form-label small fw-semibold">
                          CC Email Address
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="ccRecipients"
                          value={ccRecipients.ccRecipient}
                          onChange={handleInputChange}
                          placeholder="Enter CC Recipient email"
                          required
                        />
                      </div>
                      <div className="col-12 text-end">
                        <button
                          type="button"
                          className="btn-hm-primary"
                          onClick={handleSaveCcRecipients}
                        >
                          Save Recipient
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Existing Configurations Table */}
            <div className="col-12">
              <div className="hm-card">
                <div className="hm-card-header">
                  <h3 className="hm-card-title">
                    <i className="material-icons">dns</i>
                    Existing Configurations
                  </h3>
                </div>
                <div className="hm-card-body p-0">
                  <div style={{ overflowX: "auto" }}>
                    <table className="hm-table">
                      <thead>
                        <tr>
                          <th>Host</th>
                          <th>Port</th>
                          <th>Username</th>
                          <th>Password</th>
                          <th className="text-end pe-4">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {configs.length === 0 ? (
                          <tr>
                            <td colSpan="5">
                              <div className="hm-empty-state py-4">
                                <i className="material-icons">dns</i>
                                <p>{loading ? "Loading configurations..." : "No configurations available"}</p>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          configs.map((config, index) => (
                            <tr key={index}>
                              <td className="fw-semibold">{config.host}</td>
                              <td>{config.port}</td>
                              <td>{config.username}</td>
                              <td>
                                <div className="d-flex align-items-center gap-2">
                                  <span>
                                    {showConfigPasswords[index] ? config.password : "••••••••"}
                                  </span>
                                  <span
                                    onClick={() => toggleConfigPasswordVisibility(index)}
                                    className="text-muted"
                                    style={{ cursor: "pointer" }}
                                  >
                                    {showConfigPasswords[index] ? <FaEyeSlash /> : <FaEye />}
                                  </span>
                                </div>
                              </td>
                              <td className="text-end pe-4">
                                <button
                                  className="btn btn-sm btn-outline-danger p-1 border-0 rounded-circle"
                                  title="Delete Configuration"
                                  onClick={() => handleDelete(config)}
                                >
                                  <FaTrash />
                                </button>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {/* CC Recipients List Table */}
            <div className="col-12">
              <div className="hm-card">
                <div className="hm-card-header">
                  <h3 className="hm-card-title">
                    <i className="material-icons">people</i>
                    CC Recipients List
                  </h3>
                </div>
                <div className="hm-card-body p-0">
                  <div style={{ overflowX: "auto" }}>
                    <table className="hm-table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Recipient Email</th>
                          <th className="text-end pe-4">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {existingCcRecipients.length === 0 ? (
                          <tr>
                            <td colSpan="3">
                              <div className="hm-empty-state py-4">
                                <i className="material-icons">people</i>
                                <p>{loading ? "Loading recipients..." : "No CC recipients configured"}</p>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          existingCcRecipients.map((ccr, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td className="fw-semibold">{ccr.ccRecipient}</td>
                              <td className="text-end pe-4">
                                <div className="d-inline-flex align-items-center gap-2">
                                  <button
                                    className="btn btn-sm btn-outline-warning p-1 border-0 rounded-circle"
                                    title="Edit Recipient"
                                    onClick={() => handleUpdateRecipient(ccr)}
                                  >
                                    <FaEdit />
                                  </button>
                                  <button
                                    className="btn btn-sm btn-outline-danger p-1 border-0 rounded-circle"
                                    title="Delete Recipient"
                                    onClick={() => handleDeleteCcRecipient(ccr.id)}
                                  >
                                    <FaTrash />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Update Recipient Modal */}
      <Modal show={isRecipientUpdateModal} onHide={() => setIsRecipientUpdateModal(false)} centered>
        <Modal.Header closeButton className="hm-card-header">
          <Modal.Title className="hm-card-title">
            <i className="material-icons">edit</i>
            Update CC Recipient
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form.Group className="mb-3">
            <Form.Label className="small fw-semibold">CC Recipient Email</Form.Label>
            <Form.Control
              type="email"
              name="ccRecipient"
              value={ccRecipient.ccRecipient || ""}
              onChange={handleChangeCc}
              placeholder="Enter email address"
            />
          </Form.Group>
          <div className="d-flex align-items-center justify-content-end gap-2 pt-3 border-top">
            <button
              type="button"
              className="btn btn-outline-secondary rounded-pill px-4"
              onClick={() => setIsRecipientUpdateModal(false)}
            >
              Close
            </button>
            <button
              type="button"
              className="btn-hm-primary px-4"
              onClick={handleUpdateSelectedRecipient}
            >
              Update
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Smtpconfigure;

